import React from 'react';
import { FailureGradePieChartProps } from '@Types/failureGrade.types';
import { Box, Divider } from '@mui/material';
import { useGlobalization } from '@Translations';
import { useGradeMatrixStyles } from '@Components/deteriorationModel/gradeSetupTab/GradeMatrixStyles';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { baseChartOptions } from '@Components/deteriorationModel/utils/chartDefaults';

export const FailureGradePieChart = (props: FailureGradePieChartProps) => {
	const { t } = useGlobalization();
	const { data } = props;
	const classes = useGradeMatrixStyles();

	const chartOptions: Highcharts.Options = {
		...baseChartOptions,
		chart: {
			type: 'pie',
			height: 365,
			zooming: {
				type: 'xy',
			},
			panning: {
				enabled: true,
				type: 'xy',
			},
			panKey: 'shift',
		},
		title: {
			text: '',
		},
		tooltip: {
			headerFormat: '',
			pointFormat:
				'<span style="color:{point.color}">●</span> <b>{point.name}</b><br/>Asset Count: {point.y}<br/>Asset (%): {point.percentage:.1f}%',
		},
		plotOptions: {
			pie: {
				allowPointSelect: true,
				cursor: 'pointer',
				dataLabels: [
					{
						enabled: true,
						distance: 20,
						format: '{point.name}',
					},
				],
			},
		},
		series: [
			{
				name: 'Failure Grade',
				data: data,
				type: 'pie',
			},
		],
	};

	return (
		<Box sx={{ border: '1px solid rgb(224 224 224)', width: '100%', display: 'inline-block' }}>
			<div className={classes.matrixHeaderContainer}>
				<span className={classes.matrixHeaderText}>{t('Failure Grade Breakdown')}</span>
			</div>
			<Divider />
			<div>
				<HighchartsReact
					highcharts={Highcharts}
					options={chartOptions}
					containerProps={{ style: { height: '100%', width: '100%' } }}
				/>
			</div>
		</Box>
	);
};
